export const DATE_FORMAT = 'DD.MM.YYYY';
export const DATETIME_FORMAT = 'DD.MM.YYYY HH:mm'
export const DATE_RANGE_FILTER_FORMAT = 'YYYY-MM-DD HH:mm:ss'
export const DATE_FILTER_FORMAT = 'dd.MM.yyyy'
export const FILTER_DATE_FORMAT = 'YYYY-MM-DD'


// WEBPACK FOOTER //
// ./src/const/index.js